import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./status.module.scss";

export function ArbitrationStatus() {
  const { t } = useTranslation();
  return (
    <Pill
      styleName="arbitration"
      Lefticon={<img src={"../../../assets/images/svg/arbitration.svg"} />}>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_delivery_inspection_escalation_contract_status_title")}
      </p>
    </Pill>
  );
}
